export const lockStatusEnum = Object.freeze({
  LOCKED: 'locked',
  UNLOCKED: 'unlocked',
  LOCKING: 'locking',
  UNLOCKING: 'unlocking',
  DEACTIVATED: 'deactivated',
  ACTIVE: 'active',
});
